import React from 'react';
import singleSearchItem from 'components/Hocs/GroupsSearchNewCollector/SingleSearchItem';
import ColumnsContent from 'components/Hocs/ColumnsContent';

import ExecutionsMyTasksList from './ExecutionsMyTasksList';
import rightSidebarMyTasks from './rightSidebarMyTasks';

const Content = singleSearchItem(
  ColumnsContent(ExecutionsMyTasksList, rightSidebarMyTasks)
);

export default props => (
  <Content
    {...props}
    listReduceName="tasksModule.lists.tasksExecsListByTaskOwner"
  />
);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/MyTasks/ExecutionsMyTasksList/index.js